export const restrictedData: string[] = ["01", "02", "03", "04", "05", "06"]